<!--  -->
<template>
    <div class="luntan">
        <div class="content flex-align">
            <img src="../assets/new/luntan.jpg" alt="">
            <div class="text flex-column">
                <span>2024年京蒙教育协同发展论坛</span>
                <p> 京蒙教育协同发展论坛是全国教育家服务京蒙的高峰论坛，是北京名师教学改革的引领讲坛，是草原教育英才的那达慕大会，也是内蒙古自治区学生才艺展示的大舞台。京蒙教育东西部协作的成果需要逐步积累，不断显化，特别是不同项目任务中涌现出的名校、
                    名校长、名师、名教研员以及才华初现的学子，迫切需要一个成长阶梯。设置每年一届的京蒙教育协同发展论坛，做到双向奔赴，双向受益。</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        methods: {},
        mounted() {},
    };
</script>
<style lang='less' scoped>
    @import url("./less/forum.less");
</style>